import { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import { Sidebar } from './shell/sidebar';
import { Header } from './shell/header';
import { DomainExpiryGate } from './domain-expiry-gate';

/**
 * Phase 13 admin shell. Sidebar on the left, sticky header above the content
 * column. Sidebar collapse state persists in localStorage so the operator
 * keeps their preference across reloads.
 */

const COLLAPSE_KEY = 'mlm.admin.sidebar.collapsed';

export function Layout() {
  const [collapsed, setCollapsed] = useState<boolean>(() => {
    if (typeof window === 'undefined') return false;
    return window.localStorage.getItem(COLLAPSE_KEY) === '1';
  });

  useEffect(() => {
    window.localStorage.setItem(COLLAPSE_KEY, collapsed ? '1' : '0');
  }, [collapsed]);

  return (
    <div className="min-h-screen flex bg-background text-foreground">
      <DomainExpiryGate />
      <Sidebar collapsed={collapsed} onToggleCollapsed={() => setCollapsed((v) => !v)} />
      <div className="flex-1 flex flex-col min-w-0">
        <Header />
        <main className="flex-1 px-6 py-6">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
